import { NotificationsFeedBodyQuery } from "graphql/_Types";
import { useCallback } from "react";
import { NotificationAlertProjectClonedSucceeded } from "./NotificationAlertProjectClonedSucceeded";
import { NotificationAlertProjectClonedFailed } from "./NotificationAlertProjectClonedFailed";
import { ExternalRegion } from "ideas.env";

interface NotificationAlertProjectClonedProps {
  data: NonNullable<
    NotificationsFeedBodyQuery["notifications"]
  >["nodes"][number] & { region?: ExternalRegion };
  onNotificationRead: (
    notificationId: string,
    region?: ExternalRegion,
    refetchNotifications?: () => void,
  ) => void;
  refetchNotifications: () => void;
}

/** Component that renders a notification that a project has finished cloning */
export const NotificationAlertProjectCloned = ({
  data,
  onNotificationRead,
  refetchNotifications,
}: NotificationAlertProjectClonedProps) => {
  const { hasSeen, id: notificationId } = data;
  const attrs = data.projectClonedNotification;

  const onNotificationReadMemoized = useCallback(() => {
    if (!hasSeen) {
      onNotificationRead(notificationId, data.region, refetchNotifications);
    }
  }, [
    hasSeen,
    notificationId,
    onNotificationRead,
    refetchNotifications,
    data.region,
  ]);

  if (attrs?.succeeded) {
    return (
      <NotificationAlertProjectClonedSucceeded
        data={data}
        onNotificationRead={onNotificationReadMemoized}
      />
    );
  }

  return (
    <NotificationAlertProjectClonedFailed
      data={data}
      onNotificationRead={onNotificationReadMemoized}
    />
  );
};
